import Base from '@studiometa/js-toolkit';
import Flickity from 'flickity';
import withBreakpointObserver from '@studiometa/js-toolkit/decorators/withBreakpointObserver';

/**
 * Class
 */
export default class Slider extends withBreakpointObserver(Base) {
  /**
   * Config
   */
  get config() {
    return {
      name: 'Slider',
      activeBreakpoints: 'xxs xs s',
    };
  }

  /**
   * Mounted hook
   */
  mounted() {
    this.slider = new Flickity(this.$refs.container, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      ...this.$options,
    });

    this.slider.on('change', (index) => {
      this.$refs.progress.style.transform = `scaleX(${1 / (this.$refs.slide.length - index)})`;
    });
  }

  /**
   * Destroyed hook
   */
  destroyed() {
    this.slider.destroy();
  }
}
